import { z } from "zod";
import {
  ConnectionRequestIdPublicSchema,
  EventParticipantIdPublicSchema,
} from "./branded-id.schemas.js";
import { IntroRequestSchema } from "./intro-request.schemas.js";
import { ConnectionRequestTypeSchema } from "./connection-request-registry.schemas.js";
import { IntroRequestStatusSchema } from "./intro-request-state.schemas.js";
import { localizedTextSchema } from "./localized-text-json.schemas.js";
import { ParticipantPhotoUrlSchema } from "./participant-photo-url.schemas.js";

export const _connectionRequestCreatableSchema = z.object({
  type: ConnectionRequestTypeSchema,
  typeData: IntroRequestSchema,
});

export const ConnectionRequestCreatableSchema =
  _connectionRequestCreatableSchema.readonly();
export type ConnectionRequestCreatable = z.infer<
  typeof ConnectionRequestCreatableSchema
>;

export const _connectionRequestSchema =
  _connectionRequestCreatableSchema.extend({
    idPublic: ConnectionRequestIdPublicSchema,
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
  });

export const ConnectionRequestSchema = _connectionRequestSchema.readonly();
export type ConnectionRequest = z.infer<typeof ConnectionRequestSchema>;

const _connectionRequestSummaryTypeDataSchema = z.object({
  type: z.literal("intro"),
  status: IntroRequestStatusSchema,
  message: localizedTextSchema.nullable(),
});
export type ConnectionRequestSummaryTypeData = z.infer<
  typeof _connectionRequestSummaryTypeDataSchema
>;

const _connectionRequestSummarySchema = z.object({
  idPublic: ConnectionRequestIdPublicSchema,
  type: ConnectionRequestTypeSchema,
  typeData: _connectionRequestSummaryTypeDataSchema,
  fromParticipantIdPublic: EventParticipantIdPublicSchema,
  fromUserName: z.string(),
  fromUserPhotoUrl: ParticipantPhotoUrlSchema.nullable(),
  fromUserHeadline: z.string().nullable(),
  fromUserCompany: z.string().nullable(),
  toParticipantIdPublic: EventParticipantIdPublicSchema,
  toUserName: z.string(),
  toUserPhotoUrl: ParticipantPhotoUrlSchema.nullable(),
  toUserHeadline: z.string().nullable(),
  toUserCompany: z.string().nullable(),
  createdAt: z.coerce.date(),
  acceptedAt: z.coerce.date().nullable(),
});

export const ConnectionRequestSummarySchema =
  _connectionRequestSummarySchema.readonly();
export type ConnectionRequestSummary = z.infer<
  typeof ConnectionRequestSummarySchema
>;

export const ConnectionRequestDirectionSchema = z.enum([
  "sent",
  "received",
  "all",
]);
export type ConnectionRequestDirection = z.infer<
  typeof ConnectionRequestDirectionSchema
>;
export const ConnectionRequestDirection = ConnectionRequestDirectionSchema.enum;

export const ConnectionRequestActionSchema = z.enum(["accept", "decline"]);
export type ConnectionRequestAction = z.infer<
  typeof ConnectionRequestActionSchema
>;
export const ConnectionRequestAction = ConnectionRequestActionSchema.enum;
